import { QueryKey, useQuery } from '@tanstack/react-query';
import { useLocale } from 'next-intl';

import { ShowingDto } from '@cineamo/api/models/showing/ShowingDto.types';

import { MovieVersionDto } from '@cineamo/api/helpers/movie-helper';

import { CachedShowingData, getCachedShowingData } from '@cineamo/composables/src/hooks/content/useCachedShowingData';

import { useDomainConfiguration } from '@/providers/DomainConfigurationProvider';

export type { CachedShowingData } from '@cineamo/composables/src/hooks/content/useCachedShowingData';
/** @deprecated Use `CachedShowingData`. */
export type CachedShowingDataReturn = CachedShowingData;

/**
 * React binding of the shared showing resolution. All this adds is the domain's cinema as the
 * country context — the resolution itself is the shared one, identical to every other app's.
 */
export function useCachedShowingData<TKey extends QueryKey = QueryKey>(
    showing: ShowingDto,
    showingMovie: MovieVersionDto | null | undefined,
    deps?: TKey
): CachedShowingData | null {
    const locale = useLocale();
    const domainConfiguration = useDomainConfiguration();
    const countryCode = domainConfiguration.cinema.countryCode;

    const { data } = useQuery({
        queryKey: [
            'cached-showing-data',
            `showingId-${showing?.id}`,
            `locale-${locale}`,
            ...(deps ?? []).map((dep) => JSON.stringify(dep))
        ],
        queryFn: () =>
            getCachedShowingData(showing, showingMovie, countryCode || showing?._embedded?.cinema?.countryCode, locale)
    });
    return data || null;
}
